import { axiosInstance } from "../axios-Instance";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { queryKeys } from "../react-query/constants";
import { getLoginToken } from "../storage";

async function getTemplates() {
  const data = await axiosInstance({
    url: "/templates",
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getLoginToken()}`,
    },
  });

  return data?.data?.data;
}

const createTemplates = async (formData: any) => {
  const data = await axiosInstance({
    url: "/templates",
    method: "POST",
    data: formData,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getLoginToken()}`,
    },
  });
  return data;
};

const updateTemplates = async (formData: any) => {
  const data = await axiosInstance({
    url: `/templates/${formData["_id"]}`,
    method: "PUT",
    data: formData,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getLoginToken()}`,
    },
  });
  return data;
};

const deleteTemplates = async (formData: any) => {
  const data = await axiosInstance({
    url: `/templates/${formData}?hard=true`,
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getLoginToken()}`,
    },
  });
  return data;
};

export function useTemplates() {
  const fallback: any = [];
  const { data = fallback } = useQuery({
    queryKey: [queryKeys.templates],
    queryFn: () => getTemplates(),
  });
  return data;
}

export function useCreateTemplates() {
  const queryClient = useQueryClient();
  const { mutate, isSuccess, reset, isError, error } = useMutation({
    mutationFn: (formData) => createTemplates(formData),
    onSuccess: (data) => {
      queryClient.invalidateQueries([queryKeys.templates]);
    },
  });
  return { mutate, isSuccess, reset, isError, error };
}

export function useUpdateTemplates() {
  const queryClient = useQueryClient();
  const { mutate, isSuccess, reset, isError, error } = useMutation({
    mutationFn: (formData) => updateTemplates(formData),
    onSuccess: (data) => {
      queryClient.invalidateQueries([queryKeys.templates]);
    },
  });
  return { mutate, isSuccess, reset, isError, error };
}

export function useDeleteTemplates() {
  const queryClient = useQueryClient();
  const { mutate, isSuccess, reset, isError, error } = useMutation({
    mutationFn: (formData) => deleteTemplates(formData),
    onSuccess: (data) => {
      //   toast.success("Templates Deleted Successfully", toastOptions);
      queryClient.invalidateQueries([queryKeys.templates]);
    },
  });
  return { mutate, isSuccess, reset, isError, error };
}
